module.exports = __webpack_public_path__ + "img/icon-payment-decline.5855c335.png";